import React from "react";
import * as dc from "dc";
import * as d3 from 'd3';
import { ChartTemplate } from "./chartTemplate";

//const self = this;
const barChartFunc = (divRef, ndx) => {
    //console.log('dim '+this.props.dim)
    const myChart = dc.rowChart(divRef);

    const dimension = ndx.dimension(function (d) {
      //const teacher = [d.teacher, d.teacher_id]
      return d.teacher
    });

    const group = dimension.group().reduce(
     function(p, v) { // add
       ++p.count;
       if(p.count > 0) {
         p.totalWords += v.n_of_words;
         p.avgWords = Math.floor(parseFloat(100*p.totalWords/p.count))/100;
         p.totalVocabulary += v.vocabulary_used;
         p.avgVocabulary = Math.floor(parseFloat(100*p.totalVocabulary/p.count))/100;
         if(v.project_id in p.p_ids){
           p.p_ids[v.project_id] += 1
         }
         else{
             p.p_ids[v.project_id] = 1;
             p.id_count++;
         }
       }
       else {
         p.avgWords = 0;
         p.totalWords = 0;
         p.totalVocabulary = 0;
         p.avgVocabulary = 0;
         p.id_count = 0;
         p.p_ids = {};
       }
       return p;
     },
     function(p, v) { // remove
       --p.count;
       if(p.count > 0) {
         p.totalWords -= v.n_of_words;
         p.avgWords = Math.floor(parseFloat(100*p.totalWords/p.count))/100;
         p.totalVocabulary -= v.vocabulary_used;
         p.avgVocabulary = Math.floor(parseFloat(100*p.totalVocabulary/p.count))/100;
         if(v.project_id in p.p_ids){
           p.p_ids[v.project_id] -= 1
         }
         if(p.p_ids[v.project_id] === 0){
             delete p.p_ids[v.project_id];
             p.id_count--;
         }
       }
       else {
         p.avgWords = 0;
         p.totalWords = 0;
         p.totalVocabulary = 0;
         p.avgVocabulary = 0;
         p.id_count = 0;
         p.p_ids = {};
       }
       return p;
     },
     function() { // init
         return {count: 0, totalWords: 0, avgWords: 0, totalVocabulary: 0, avgVocabulary: 0,id_count: 0, p_ids: {}};
     }
   );

  const size = group.size();
  const barHeight = 18;
  let LabelPadding = 0;

    myChart
    .dimension(dimension)
    .group(group)
    .valueAccessor(function (p) {
       return p.value.count ;
     })
    //.ordering(function(d){ return d.value.count})
    .elasticX(true)
    //.elasticY(true)
    .margins({ top: 5, right: 30, bottom: 25, left: 100 })
    .labelOffsetX(-100)
    .height(30 + size*(barHeight+2))
    .gap(2)
    .ordinalColors([ "#065FE5"])
    .transitionDuration(1000)
    .renderTitleLabel(true)
    .title(function(d) {
      return d3.format(",d")(d.value.count); // or your custom value accessor
    })
    .fixedBarHeight(barHeight)
    .xAxis().ticks(6)

    myChart.on('pretransition', function(chart) {
      const padding = 10;
      //chart.ordering(function(d){ return d.value.count})


      const label = chart.selectAll('g.row  text:nth-child(3)'); //find all row labels
      label.attr('x', padding) //move labels to starting position

      .transition() //start transition
      .duration(chart.transitionDuration()) //use chart's transitionDuration so labels animate with rows
      .attr('x', function(d){ //set label final position
          var dataValue = chart.valueAccessor()(d); //use chart's value accessor as basis for row label position
          var scaledValue = chart.xAxis().scale()(dataValue); //convert numeric value to row width
          if(scaledValue < 30) {
            d.LabelPadding = padding;
            return  padding;
          }
          d.LabelPadding = scaledValue - padding;
          return scaledValue - padding; //return scaled value to set label position
      })
      label.classed('label_text',function(d) {
        if(d.LabelPadding <= padding)
          return false;
        else return true;
      })
      label.classed('label_text1',function(d) {
        if(d.LabelPadding > padding)
          return false;
        else return true;
      })

      //chart.ordering(function(d){ return d.value.count})
    });



    return myChart
}

export const Teachers = props => (
  <ChartTemplate chartFunction={barChartFunc} title={props.title} dim={props.dim} metric={props.metric} type={props.type}
    showMetricsSelector={props.showMetricsSelector} reset={false}/>
)
